export default "__VITE_ASSET__wELf1HF7__"